import Node from './Node';

export default class Message extends Node {
  constructor(slashShrug, segments, shrug) {
    super();
    this.slashShrug = slashShrug;
    this.segments = segments;
    this.shrug = shrug;
  }

  finalize() {
    this.emojiCount = 0;
    this.emojiOnly = undefined;
    this.slashShrug?.finalize(this, this);
    this.segments.forEach((s) => s.finalize(this, this));
    this.shrug?.finalize(this, this);
  }

  toJSON() {
    return {
      slashShrug: this.slashShrug?.toJSON(),
      segments: this.segments.map((s) => s.toJSON()),
      shrug: this.shrug?.toJSON(),
      emojiCount: this.emojiCount,
      emojiOnly: this.emojiOnly,
    };
  }

  toSource() {
    return [this.slashShrug?.toSource(), ...this.segments.map((s) => s.toSource()), this.shrug?.toSource()]
      .filter(Boolean)
      .join('');
  }
}
